/* import __COLOCATED_TEMPLATE__ from './power-calendar.hbs'; */
var _dec, _dec2, _class2, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { action } from '@ember/object';
import { guidFor } from '@ember/object/internals';
import { inject as service } from '@ember/service';
import { task } from 'ember-concurrency';
import { assert } from '@ember/debug';
import { add, normalizeDate, normalizeCalendarValue } from 'ember-power-calendar/utils';
import PowerCalendarNavComponent from './power-calendar/nav';
import PowerCalendarDaysComponent from './power-calendar/days';
let _class = (_dec = service('power-calendar'), _dec2 = task(function* (newCenter, calendar, e) {
  assert("You attempted to move the center of a calendar that doesn't receive an `@onCenterChange` action.", typeof this.args.onCenterChange === 'function');
  let value = normalizeCalendarValue({
    date: newCenter
  });
  yield this.args.onCenterChange(value, calendar, e);
}), _class2 = class _class2 extends Component {
  // Lifecycle hooks
  constructor() {
    super(...arguments);
    _initializerDefineProperty(this, "powerCalendarService", _descriptor, this);
    _initializerDefineProperty(this, "center", _descriptor2, this);
    _initializerDefineProperty(this, "_calendarType", _descriptor3, this);
    _initializerDefineProperty(this, "_selected", _descriptor4, this);
    _defineProperty(this, "navComponent", PowerCalendarNavComponent);
    _defineProperty(this, "daysComponent", PowerCalendarDaysComponent);
    // Tasks
    _initializerDefineProperty(this, "changeCenterTask", _descriptor5, this);
    this.registerCalendar();
    if (this.args.onInit) {
      this.args.onInit(this.publicAPI);
    }
  }
  get publicActions() {
    let actions = {};
    if (this.args.onSelect) {
      actions.select = (...args) => this.select(...args);
    }
    if (this.args.onCenterChange) {
      let changeCenter = (newCenter, calendar, e) => {
        return this.changeCenterTask.perform(newCenter, calendar, e);
      };
      actions.changeCenter = changeCenter;
      actions.moveCenter = (step, unit, calendar, e) => {
        let newCenter = add(this.currentCenter, step, unit);
        return changeCenter(newCenter, calendar, e);
      };
    }
    return actions;
  }
  get selected() {
    if (this._selected) {
      return this._selected;
    }
    return normalizeDate(this.args.selected);
  }
  set selected(v) {
    this._selected = normalizeDate(v);
  }
  get currentCenter() {
    let center = this.args.center;
    if (!center) {
      center = this.selected || this.powerCalendarService.getDate();
    }
    return normalizeDate(center);
  }
  get publicAPI() {
    return this._publicAPI;
  }
  get _publicAPI() {
    return {
      uniqueId: guidFor(this),
      type: this._calendarType,
      selected: this.selected,
      loading: this.changeCenterTask.isRunning,
      center: this.currentCenter,
      locale: this.args.locale || this.powerCalendarService.locale,
      actions: this.publicActions
    };
  }
  get tagWithDefault() {
    if (this.args.tag === undefined || this.args.tag === null) {
      return 'div';
    }
    return this.args.tag;
  }

  // Actions
  select(day, calendar, e) {
    if (this.args.onSelect) {
      this.args.onSelect(day, calendar, e);
    }
  }
  destroyElement() {
    this.unregisterCalendar();
  }
  // Methods
  registerCalendar() {
    if (window) {
      window.__powerCalendars = window.__powerCalendars || {}; // TODO: weakmap??
      window.__powerCalendars[this.publicAPI.uniqueId] = this;
    }
  }
  unregisterCalendar() {
    if (window) {
      delete window.__powerCalendars[guidFor(this)];
    }
  }
}, _descriptor = _applyDecoratedDescriptor(_class2.prototype, "powerCalendarService", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class2.prototype, "center", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return null;
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class2.prototype, "_calendarType", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return 'single';
  }
}), _descriptor4 = _applyDecoratedDescriptor(_class2.prototype, "_selected", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class2.prototype, "select", [action], Object.getOwnPropertyDescriptor(_class2.prototype, "select"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "destroyElement", [action], Object.getOwnPropertyDescriptor(_class2.prototype, "destroyElement"), _class2.prototype), _descriptor5 = _applyDecoratedDescriptor(_class2.prototype, "changeCenterTask", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _class2);
export { _class as default };